import React, { useEffect, createElement } from 'react';
import { CTAButton } from './CTAButton';
function loadWistiaScript(mediaId: string) {
  if (!document.querySelector('script[src="https://fast.wistia.com/player.js"]')) {
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
  }
  const embedSrc = `https://fast.wistia.com/embed/${mediaId}.js`;
  if (!document.querySelector(`script[src="${embedSrc}"]`)) {
    const embedScript = document.createElement('script');
    embedScript.src = embedSrc;
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
  }
}
export function TestimonialsSection() {
  useEffect(() => {
    loadWistiaScript('anp9idj72r');
    loadWistiaScript('psa74yg6wr');
    loadWistiaScript('n6ngvv6hee');
  }, []);
  return <section className="bg-light py-28 md:py-32 px-4" data-id="element-220">
      <div className="max-w-[1100px] mx-auto flex flex-col items-center" data-id="element-221">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-textDark mb-6 text-center" data-id="element-222">
          Cuando haces el ajuste… se nota.
        </h2>
        <p className="text-xl md:text-2xl text-textSecondary mb-20 text-center max-w-3xl leading-relaxed" data-id="element-223">
          No porque trabajes más. Sino porque con menos horas de trabajo,
          construyes más crecimiento.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 w-full mb-24" data-id="element-224">
          <div className="flex flex-col items-center mx-auto w-full" data-id="element-225">
            <div className="mb-8 rounded-xl overflow-hidden shadow-xl" style={{
            width: '100%',
            maxWidth: '320px',
            margin: '0 auto'
          }} data-id="element-226">
              <style data-id="element-227">{`
                wistia-player[media-id='anp9idj72r']:not(:defined) {
                  background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/anp9idj72r/swatch');
                  display: block;
                  filter: blur(5px);
                  padding-top: 177.5%;
                }
              `}</style>
              {/* @ts-ignore */}
              <wistia-player media-id="anp9idj72r" aspect="0.5633802816901409" style={{
              width: '100%'
            }} data-id="element-228"></wistia-player>
            </div>
            <p className="text-center text-textSecondary italic text-lg leading-relaxed" data-id="element-229">
              Cecilia Sigala - MEXICO "....¿Qué valor le pones a tu tiempo? Eso
              es todo muy muy, para mí, muy revelador...."
            </p>
          </div>

          <div className="flex flex-col items-center mx-auto w-full" data-id="element-230">
            <div className="mb-8 rounded-xl overflow-hidden shadow-xl" style={{
            width: '100%',
            maxWidth: '320px',
            margin: '0 auto'
          }} data-id="element-231">
              <style data-id="element-232">{`
                wistia-player[media-id='psa74yg6wr']:not(:defined) {
                  background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/psa74yg6wr/swatch');
                  display: block;
                  filter: blur(5px);
                  padding-top: 177.78%;
                }
              `}</style>
              {/* @ts-ignore */}
              <wistia-player media-id="psa74yg6wr" aspect="0.5625" style={{
              width: '100%'
            }} data-id="element-233"></wistia-player>
            </div>
            <p className="text-center text-textSecondary italic text-lg leading-relaxed" data-id="element-234">
              Luis Muñoz - AKAGEL - Colombia "...herramientas claras y precisas
              que me han permitido ver mi negocio desde una nueva perspectiva y
              llevarlo a otro nivel..."
            </p>
          </div>

          <div className="flex flex-col items-center mx-auto w-full" data-id="element-235">
            <div className="mb-8 rounded-xl overflow-hidden shadow-xl" style={{
            width: '100%',
            maxWidth: '320px',
            margin: '0 auto'
          }} data-id="element-236">
              <style data-id="element-237">{`
                wistia-player[media-id='n6ngvv6hee']:not(:defined) {
                  background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/n6ngvv6hee/swatch');
                  display: block;
                  filter: blur(5px);
                  padding-top: 177.78%;
                }
              `}</style>
              {/* @ts-ignore */}
              <wistia-player media-id="n6ngvv6hee" aspect="0.5625" style={{
              width: '100%'
            }} data-id="element-238"></wistia-player>
            </div>
            <p className="text-center text-textSecondary italic text-lg leading-relaxed" data-id="element-239">
              Luis Gerardo Martinez - Asesor Terrenos - HOUSTON - "...con estas
              herramientas, este cambio de mentalidad que tú le acabas de dar,
              vamos a tener resultados positivos..."
            </p>
          </div>
        </div>

        <div className="w-full max-w-4xl mx-auto mb-20 text-center" data-id="element-240">
          <p className="font-serif italic text-2xl md:text-4xl text-textDark font-bold leading-tight" data-id="element-241">
            "Entendí cuánto vale realmente una hora de mi tiempo... y eso cambió
            completamente cómo trabajo."
          </p>
        </div>

        <p className="text-xl md:text-2xl text-textDark mb-12 text-center max-w-3xl leading-relaxed font-medium" data-id="element-242">
          No es magia.
          <br data-id="element-243" />
          Es lo que pasa cuando cierras tus fugas y te concentras en el 20% que
          sí genera crecimiento.
        </p>

        <CTAButton className="w-full md:w-auto" data-id="element-244">QUIERO VER MI 20%</CTAButton>
      </div>
    </section>;
}